import { type JSX } from 'react';
import Box from '@mui/material/Box';
import { type TextFieldProps } from '@mui/material/TextField';
import { Input, type InputProps } from '../input';
import { Status } from '../../status';

export type TimeInputFieldProps = TextFieldProps & Pick<InputProps, 'hasError'>;

export const TimeInputField = (props: TimeInputFieldProps): JSX.Element => {
  // Remove MUI props passed in that we override in our component.
  // The rest are passed to our input as that provides all the default behaviour required for the Date Picker to function.
  delete props.size;
  delete props.contentEditable;

  const { hasError, InputProps, ...rest } = props;

  return (
    <Input
      size='regular'
      hasError={hasError}
      isClearIconShown={true}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <>
            {Boolean(hasError) && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mr: 1,
                }}
              >
                <Status statusLevel='error' size={20} />
              </Box>
            )}
            {InputProps?.endAdornment}
          </>
        ),
      }}
      {...(rest as Omit<TextFieldProps, 'size' | 'contentEditable' | 'value'>)}
    />
  );
};
